/**
 * 緯度として有効な数値か判定する（-90〜90 の有限値）
 */
const isValidLatitude = (value: number | null | undefined): value is number => {
  return typeof value === 'number' && Number.isFinite(value) && value >= -90 && value <= 90;
};

/**
 * 経度として有効な数値か判定する（-180〜180 の有限値）
 */
const isValidLongitude = (value: number | null | undefined): value is number => {
  return typeof value === 'number' && Number.isFinite(value) && value >= -180 && value <= 180;
};

/**
 * 体験の緯度経度から Google Maps の検索 URL を生成する。
 *
 * - 緯度・経度の両方が有効な値（有限かつ値域内）のときのみ URL を返す。
 * - いずれかが欠落・不正値の場合は null を返す（座標なし＝リンク非表示）。
 * - 形式は `https://www.google.com/maps/search/?api=1&query=<lat>,<lng>`。
 *
 * @param {number | null | undefined} latitude - 緯度
 * @param {number | null | undefined} longitude - 経度
 * @returns {string | null} Google Maps 検索 URL。座標が無い/不正な場合は null
 */
export const buildGoogleMapsSearchUrl = (latitude: number | null | undefined, longitude: number | null | undefined): string | null => {
  if (!isValidLatitude(latitude) || !isValidLongitude(longitude)) return null;
  return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
};
